<template>
  <div class="time-sheet">
    <CCard class="filter">
      <CRow>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2">
            <CCol col="12">
              <label>{{ $t("timeSheets.start_date") }}</label>
            </CCol>
            <CCol col="12">
              <DatePickerFormFlex
                :propsDate="searchData.start_date"
                @emitDate="startDate"
                v-model="searchData.start_date"
                v-on:keyup.enter="search"
              />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2">
            <CCol col="12">
              <label>{{ $t("timeSheets.end_date") }}</label>
            </CCol>
            <CCol col="12">
              <DatePickerFormFlex
                :propsDate="searchData.end_date"
                @emitDate="endDate"
                v-model="searchData.end_date"
                v-on:keyup.enter="search"
              />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol col="12">
              <label>{{ $t("label.member_companies") }}</label>
            </CCol>
            <CCol col="12">
              <select
                class="form-control form-group"
                v-model="searchData.company_code"
                @change="search"
              >
                <option value="0">{{
                    $t("placeholder.label_employee_option_search")
                  }}
                </option>
                <option
                  v-for="(company, index) in companies"
                  :key="index"
                  :value="index"
                >{{ company.name }}
                </option
                >
              </select>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol sm="12">
              <label>{{ $t("timeSheets.id_name") }}</label>
            </CCol>
            <CCol sm="12">
              <CInput
                type="text"
                v-model="searchData.employee_info"
                v-on:keyup.enter="search"
              />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol sm="12">
              <label>Foot</label>
            </CCol>
            <CCol sm="12">
              <select
                class="form-control form-group"
                v-model="searchData.foot_code"
                @change="search"
              >
                <option value="0">{{
                    $t("placeholder.label_employee_option_search")
                  }}
                </option>
                <option
                  v-for="foot in foots"
                  :key="foot.id"
                  :value="foot.code"
                >{{ foot.name }}
                </option
                >
              </select>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol sm="12">
              <label>{{ $t("label.division") }}</label>
            </CCol>
            <CCol sm="12">
              <select
                class="form-control form-group"
                v-model="searchData.division_code"
                @change="search"
              >
                <option value="0">{{
                    $t("placeholder.label_employee_option_search")
                  }}
                </option>
                <option
                  v-for="division in filterDivision"
                  :key="division.id"
                  :value="division.code"
                >{{ division.name }}
                </option
                >
              </select>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <CRow class="justify-content-center btn-search-mb">
        <CButton @click="search" class="btn-search-timesheet">{{
            $t("label.search")
          }}
        </CButton>
        <CButton class="btn-reset" @click="resetForm">{{
            $t("button.label_action_reset")
          }}
        </CButton>
      </CRow>
    </CCard>
    <div class="table-list">
      <CCard>
        <CCardBody>
          <CRow class="justify-content-end p-2 mb-md-0 mb-3">
            <CButton color="info mr-3" @click="importTimesheet">Import</CButton>
            <CButton color="warning ml-3" @click="exportData">Export</CButton>
          </CRow>
          <div class="option-table">
            <div class="form-group">
              <select
                class="form-control"
                v-model="searchData.itemsPerPage"
                @change="search"
              >
                <option
                  v-for="item in listItemsPerPage"
                  :value="item"
                  :key="item"
                >{{ item }}
                </option
                >
              </select>
            </div>
            <template v-if="timeSheets.data && timeSheets.data.length > 0">
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ $t("commons.label_text_to") }} {{ searchData.paginate.to }}
                {{ $t("commons.label_text_of") }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template>
            <template v-else>
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ searchData.paginate.to }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template>
          </div>
          <div class="table-responsive">
            <table class="table table-mobile">
              <thead>
              <tr>
                <th>#</th>
                <th>{{ $t("label.employee_code") }}</th>
                <th>{{ $t("label.full_name") }}</th>
                <th>Foot</th>
                <th>{{ $t("label.division") }}</th>
                <th>{{ $t("timeSheets.date") }}</th>
                <th>{{ $t("timeSheets.day_of_week") }}</th>
                <th>{{ $t("timeSheets.start_time_real") }}</th>
                <th>{{ $t("timeSheets.end_time_real") }}</th>
                <th>{{ $t("timeSheets.work_time_real") }}</th>
                <th>{{ $t("timeSheets.work_time_pay") }}</th>
                <th>{{ $t("timeSheets.note") }}</th>
                <th>{{ $t("label.action") }}</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="timeSheets.data && timeSheets.data.length > 0">
                <tr
                  v-for="(timeSheet, index) in timeSheets.data"
                  :key="timeSheet.id"
                  :class="timeSheet.day_off ? 'day-off' : 'null'"
                >
                  <th>
                    {{
                      (timeSheets.current_page - 1) * timeSheets.per_page +
                      index +
                      1
                    }}
                  </th>
                  <td>{{ timeSheet.employee_id }}</td>
                  <td>{{ timeSheet.employee_name }}</td>
                  <td>{{ timeSheet.foot }}</td>
                  <td>{{ timeSheet.division }}</td>
                  <td>{{ timeSheet.work_date }}</td>
                  <td>{{ $t(`timeSheets.${timeSheet.day_of_week}`) }}</td>
                  <td>
                    {{
                      timeSheet.start_time_real
                        ? timeSheet.start_time_real
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      timeSheet.end_time_real ? timeSheet.end_time_real : "-"
                    }}
                  </td>
                  <td>
                    {{
                      timeSheet.work_time_real
                        ? timeSheet.work_time_real
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      timeSheet.work_time_pay ? timeSheet.work_time_pay : "-"
                    }}
                  </td>
                  <td>
                    <div v-if="timeSheet.late_pay">
                      - {{ $t("timeSheets.late_time") }}:
                      {{ timeSheet.late_pay }}
                    </div>
                    <div v-if="timeSheet.early_pay">
                      - {{ $t("timeSheets.early_time") }}:
                      {{ timeSheet.early_pay }}
                    </div>
                    <div v-if="timeSheet.paid_leave_time">
                      - {{ $t("timeSheets.paid_leave") }}:
                      {{ timeSheet.paid_leave_time }}
                    </div>
                    <div v-if="timeSheet.ot_time_real">
                      - {{ $t("timeSheets.ot_time_real") }}:
                      {{ timeSheet.ot_time_real }}
                    </div>
                    <div v-if="timeSheet.ot_time_real">
                      - {{ $t("timeSheets.ot_time_minus_late_early") }}:
                      {{
                        timeSheet.ot_time_minus_late_early
                          ? timeSheet.ot_time_minus_late_early
                          : "00:00"
                      }}
                    </div>
                    <div v-if="timeSheet.ot_150">
                      - {{ $t("timeSheets.ot_150_percent") }}:
                      {{ timeSheet.ot_150 }}
                    </div>
                    <div v-if="timeSheet.ot_200">
                      - {{ $t("timeSheets.ot_200_percent") }}:
                      {{ timeSheet.ot_200 }}
                    </div>
                    <div v-if="timeSheet.compensation_leave">
                      -
                      {{
                        $t(`commons.label_status_sabbatical_leave_type_1`)
                      }}: {{ timeSheet.compensation_leave }}
                    </div>
                    <div v-if="timeSheet.paid_leave">
                      -
                      {{
                        $t(`commons.label_status_sabbatical_leave_type_2`)
                      }}: {{ timeSheet.paid_leave }}
                    </div>
                    <div v-if="timeSheet.unpaid_leave">
                      -
                      {{
                        $t(`commons.label_status_sabbatical_leave_type_3`)
                      }}: {{ timeSheet.unpaid_leave }}
                    </div>
                    <div v-if="timeSheet.physiological_leave_minute">
                      -
                      {{
                        $t(`detail_employee_timesheet.label.physiological`)
                      }}: {{ timeSheet.physiological_leave_minute }} {{$t(`detail_employee_timesheet.label.date`)}} 
                    </div>
                    <div
                      v-if="
                          !timeSheet.late_pay &&
                            !timeSheet.early_pay &&
                            !timeSheet.paid_leave_time &&
                            !timeSheet.ot_time &&
                            !timeSheet.ot_time_minus_late_early &&
                            !timeSheet.ot_time &&
                            !timeSheet.ot_150 &&
                            !timeSheet.ot_200 &&
                            !timeSheet.ot_time_real &&
                            !timeSheet.ot_time_minus_late_early &&
                            !timeSheet.paid_leave &&
                            !timeSheet.compensation_leave &&
                            !timeSheet.unpaid_leave &&
                            timeSheet.physiological_leave_minute == 0
                        "
                    >
                      -
                    </div>
                  </td>
                  <td>
                    <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      @click="showFormUpdate(timeSheet)"
                    >{{ $t("button.label_action_edit") }}
                    </CButton
                    >
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="13" class="text-center">
                    {{ $t("table.label_data_not_found") }}
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </CCardBody>
        <CPagination
          v-if="timeSheets.data && timeSheets.data.length > 0"
          :activePage.sync="searchData.paginate.currentPage"
          :pages="searchData.paginate.totalPage"
          @update:activePage="fetchTimeSheetData"
          size="sm"
          align="center"
        />
      </CCard>
    </div>
    <template>
      <b-modal
        size="lg"
        ref="my-modal"
        :title="$t('label.update_timesheet')"
        hide-footer
      >
        <ValidationObserver ref="updateDataTimeSheet" v-slot="{ handleSubmit }">
          <CForm @submit.prevent="handleSubmit(updateDataTimeSheet)">
            <CRow class="mb-6">
              <CCol sm="12">
                <CRow>
                  <CCol sm="12" xl="2">
                    <label>{{ $t("label.date") }}</label>
                  </CCol>
                  <CCol sm="12" xl="4">
                    <CInput
                      type="text"
                      readonly
                      v-model="timeSheetUpdate.work_date"
                    />
                  </CCol>
                </CRow>
              </CCol>
              <CCol md="6" sm="12">
                <CRow>
                  <CCol sm="12" xl="4">
                    <label>{{ $t("label.employee_code") }}</label>
                  </CCol>
                  <CCol sm="12" xl="8">
                    <CInput
                      type="text"
                      readonly
                      v-model="timeSheetUpdate.employee_id"
                    />
                  </CCol>
                </CRow>
              </CCol>
              <CCol md="6" sm="12">
                <CRow>
                  <CCol sm="12" xl="4">
                    <label>{{ $t("label.full_name") }}</label>
                  </CCol>
                  <CCol sm="12" xl="8">
                    <CInput
                      type="text"
                      readonly
                      v-model="timeSheetUpdate.employee_name"
                    />
                  </CCol>
                </CRow>
              </CCol>
              <CCol md="6" sm="12">
                <CRow>
                  <CCol sm="12" xl="4">
                    <label>
                      {{ $t("label.start_time") }}
                      <span class="required">*</span>
                    </label>
                  </CCol>
                  <CCol sm="12" xl="8">
                    <ValidationProvider
                      rules="required|max:20"
                      v-slot="{ errors }"
                      :name="$t('label.start_time')"
                    >
                      <b-form-input
                        class="form-group mb-mobile-0"
                        type="text"
                        v-mask="'##:##'"
                        placeholder="HH:ii"
                        v-model="timeSheetUpdate.start_time_real"
                      />
                      <span class="error-required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>
              </CCol>
              <CCol md="6" sm="12">
                <CRow>
                  <CCol sm="12" xl="4">
                    <label>
                      {{ $t("label.end_time") }}
                      <span class="required">*</span>
                    </label>
                  </CCol>
                  <CCol sm="12" xl="8">
                    <ValidationProvider
                      rules="required|max:20"
                      v-slot="{ errors }"
                      :name="$t('label.end_time')"
                    >
                      <b-form-input
                        class="form-group mb-mobile-0"
                        type="text"
                        v-mask="'##:##'"
                        placeholder="HH:ii"
                        v-model="timeSheetUpdate.end_time_real"
                      />
                      <span class="error-required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <CRow class="d-flex justify-content-end mr-auto">
              <b-button type="submit" class="btn btn-success mt-3">
                {{ $t("label.save_infomation") }}
              </b-button>
              <span class="mr-2"></span>
              <b-button
                class="mt-3"
                variant="outline-danger"
                @click="hideModal"
              >{{ $t("popup.timesheet.label_cancel_button") }}
              </b-button
              >
            </CRow>
          </CForm>
        </ValidationObserver>
      </b-modal>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import XLSX from "xlsx";
import "sweetalert2/src/sweetalert2.scss";
import {ValidationProvider, ValidationObserver} from "vee-validate";
import DatePickerFormFlex from "@/components/Common/DatePickerFormFlex";
import moment from "moment";

export default {
  name: "TimeSheet",
  metaInfo() {
    return {
      title: this.$t("page_title.page_timesheet_list_old"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    DatePickerFormFlex
  },
  data() {
    return {
      timeSheetUpdate: {},
      searchData: {
        start_date: "",
        end_date: "",
        company_code: "0",
        foot_code: "0",
        division_code: "0",
        employee_info: "",
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        }
      },
      export: true
    };
  },
  created() {
    this.searchData.start_date = this.getDateSearch().firstDay;
    this.searchData.end_date = this.getDateSearch().lastDay;
    this.$route.query ? this.fillDataFilterTimeSheet(this.$route.query) : '';
    this.fetchTimeSheetData();
  },
  computed: {
    ...mapGetters({
      timeSheets: "timeSheet/timeSheets",
      timeSheetsExport: "timeSheet/timeSheetsExport",
      pagination: "timeSheet/pagination",
      companies: "commons/companies",
      foots: "commons/foots",
      divisions: "commons/divisions",
      listItemsPerPage: "commons/listItemsPerPage"
    }),
    filterDivision() {
      if (this.searchData.foot_code === "0") return this.divisions;
      return this.divisions.filter(
        division => division.parent_code === this.searchData.foot_code
      );
    }
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    fillDataFilterTimeSheet(query) {
      let endDate = this.getDateSearch().lastDay;
      if (query.month) {
        const date = moment(query.month, 'MM/YYYY');
        const month = date.format('MM');
        const year = date.format('YYYY');
        endDate = moment(`${year}-${month}-01`).endOf('month').format('DD/MM/YYYY');
      }
      query.foot === 0 || query.foot === 0 || this.foots.filter((foot) => foot.code === query.foot).length <= 0 ? this.searchData.foot_code = "0" : this.searchData.foot_code = query.foot;
      query.division || query.division === 0 || this.divisions.filter((foot) => foot.code === query.division).length <= 0 ? this.searchData.division_code = "0" : this.searchData.division_code = query.division;
      this.searchData.division_code = query.division ? query.division : this.searchData.division_code
      this.searchData.employee_info = query.id;
      this.searchData.start_date = query.month ? `01/${query.month}` : this.getDateSearch().firstDay;
      this.searchData.end_date = endDate;
    },
    startDate(data) {
      this.searchData.start_date = data;
    },

    endDate(data) {
      this.searchData.end_date = data;
    },

    resetForm() {
      this.searchData.start_date = this.getDateSearch().firstDay;
      this.searchData.end_date = this.getDateSearch().lastDay;
      this.searchData.company_code = "0";
      this.searchData.foot_code = "0";
      this.searchData.division_code = "0";
      this.searchData.employee_info = "";
    },

    async fetchTimeSheetData() {
      await this.$store.dispatch("timeSheet/fetchTimeSheet", {
        start_date: this.searchData.start_date,
        end_date: this.searchData.end_date,
        foot_code: this.searchData.foot_code,
        division_code: this.searchData.division_code,
        company_code: this.searchData.company_code,
        employee_info: this.searchData.employee_info,
        itemsPerPage: this.searchData.itemsPerPage,
        currentPage: this.searchData.paginate.currentPage
      });
      this.searchData.paginate = this.pagination;
    },
    async exportData() {
      this.setLoading(true);
      await this.$store
        .dispatch("timeSheet/fetchTimeSheetsExport", {
          start_date: this.searchData.start_date,
          end_date: this.searchData.end_date,
          foot_code: this.searchData.foot_code,
          division_code: this.searchData.division_code,
          company_code: this.searchData.company_code,
          employee_info: this.searchData.employee_info,
          export: this.export
        })
        .then(() => {
          this.setLoading(false);
          this.$toast(
            this.$t("popup.label_popup_export_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
        })
        .catch(() => {
          this.setLoading(false);
        });
      let Heading = [
        [
          "Mã nhân viên",
          "Họ và tên",
          "Ngày",
          "Thứ",
          "Vào lúc",
          "Ra lúc",
          "Giờ bắt đầu tính công",
          "Giờ kết thúc tính công",
          "Đi muộn",
          "Về sớm",
          "OT 150%",
          "OT 200%",
          "Nghỉ bù phép",
          "Nghỉ việc riêng hưởng lương",
          "Nghỉ không lương",
          "Nghỉ sinh lý",
          "Giờ công thực tế",
          "Giờ công tính lương"
        ]
      ];
      var ws = XLSX.utils.aoa_to_sheet(Heading);
      let dataExport = this.timeSheetsExport.data;
      for (var key in dataExport) {
        let dayOfWeek = dataExport[key]["day_of_week"].toLowerCase();
        dataExport[key]["day_of_week"] = this.$t("timeSheets." + dayOfWeek);
      }
      ws = XLSX.utils.sheet_add_json(ws, dataExport, {
        skipHeader: true,
        origin: "A2"
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Chi tiết công số");
      XLSX.writeFile(
        wb,
        "Chi tiết công số_" +
        Date.now() +
        "_" +
        this.searchData.start_date +
        "-" +
        this.searchData.end_date +
        ".xlsx"
      );
    },
    async search() {
      if (this.$route.query.length > 0) {
        const query = Object.assign({}, this.$route.query);
        delete query.id;
        delete query.month;
        delete query.foot;
        delete query.division;
        this.$router.replace({query});
      }
      this.searchData.paginate.currentPage = 1;
      this.setLoading(true);
      try {
        await this.fetchTimeSheetData();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },
    getDateSearch() {
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      let firstDay = "";
      if (
        moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
          "YYYY-MM-DD"
        ) <= currentDay &&
        currentDay <=
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      }
      if (
        currentDay >
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      }
      return {
        firstDay: Intl.DateTimeFormat("en-GB").format(firstDay),
        lastDay: ""
      };
    },
    importTimesheet() {
      this.$router.push({name: "time-sheets.import"});
    },
    showFormUpdate(timeSheet) {
      this.$refs["my-modal"].show();
      let cloneTimeSheet = {};
      cloneTimeSheet.id = timeSheet.id;
      cloneTimeSheet.work_date = timeSheet.work_date;
      cloneTimeSheet.employee_id = timeSheet.employee_id;
      cloneTimeSheet.employee_name = timeSheet.employee_name;
      cloneTimeSheet.start_time_real = timeSheet.start_time_real;
      cloneTimeSheet.end_time_real = timeSheet.end_time_real;
      this.timeSheetUpdate = cloneTimeSheet;
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    async updateDataTimeSheet() {
      this.setLoading(true);
      await this.$store
        .dispatch("timeSheet/updateTimeSheet", this.timeSheetUpdate)
        .then(() => {
          this.setLoading(false);
          this.hideModal();
          this.fetchTimeSheetData();
          this.$toast(
            this.$t("popup.timesheet.label_popup_update_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
        })
        .catch(() => {
          this.setLoading(false);
        });
    }
  }
};
</script>

<style scoped>
.filter {
  margin: -2rem -2rem 0rem -2rem;
  padding: 2rem;
}

.table-list {
  margin-top: 1.5rem;
}

tr.day-off {
  background-color: #f0f8ff;
}

th,
td {
  vertical-align: middle !important;
}

.required,
.error-required {
  color: #dc1313;
  font-size: 13px;
}

.option-table {
  display: flex;
  justify-content: space-between;
}

.btn-search-timesheet {
  background-color: #b5dbf2;
  padding: 8px;
  width: 120px;
}

.btn:focus,
.btn.focus {
  box-shadow: none !important;
}

@media only screen and (max-device-width: 767px) {
  .show-text-table {
    margin-left: 2.375rem;
  }

  .py-mobile-0 {
    padding: 0 !important;
  }

  .btn-search-mb {
    margin-top: 15px;
  }

  .table-mobile {
    width: 1200px;
    overflow-x: scroll;
  }

  .mb-mobile-0 {
    margin-bottom: 0;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .table-mobile {
    width: 1200px;
    overflow-x: scroll;
  }
}
</style>